<template>
  <b-container>
    <b-row v-if="success" class="text-center pt-4">
      <b-col>
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </b-col>
    </b-row>
    <b-form v-else @submit="onSubmit">
      <b-alert show variant="info">
        <b-row>
          <b-col>
            <div>
              <strong>{{ $t("title.taskAssignment") }}</strong> :
            </div>
            <b-form-select
              v-model="membersSelect"
              :options="membersList"
              multiple
              size="sm"
            ></b-form-select>
            <div>
              <small>&#9432; {{ $t("info.chooseMultiple") }}</small>
            </div>
          </b-col>
        </b-row>
      </b-alert>
      <div>
        <b-button
          class="mt-4 text-center"
          type="submit"
          variant="success"
          :disabled="disabled"
          >{{ $t("action.submit") }}</b-button
        >
        <b-button
          class="ml-3 mt-4 text-center"
          variant="danger"
          @click="removeMembersList"
          >{{ $t("action.remove") }}</b-button
        >
      </div>
      <div v-if="error" class="pt-4">
        <b-alert show variant="info">
          <p>{{ error }}</p>
        </b-alert>
      </div>

      <div v-if="spinner" class="text-center align-middle">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="success"
          label="Spinning"
          disabled="labelStatus"
        ></b-spinner>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["groupingItem", "rowItem", "showBtn" ,"modalid"],
  data() {
    return {
      form: {},
      membersSelect: [],
      membersList: [],
      spinner: false,
      disabled: false,
      error: "",
      success: false,
    };
  },
  mounted() {
    this.spinner = true;
    let accessToken = this.getGlobalData("accessToken");
    let groupId = this.rowItem.GroupId;
    this.getMemberOf(accessToken, groupId);
  },
  computed: {
    url: function () {
      return this.getUrl();
    }
  },
  methods: {
    removeMembersList() {
      let groupId = this.rowItem.GroupId;
      let groupMembersList = this.$store.getters.getGroupMemberTest;
      let newList = groupMembersList.filter((item) => {
        return item.rowItem.GroupId !== groupId;
      });
      this.$store.commit("removeGroupMembersListTest", newList);
      if (groupMembersList.length !== newList.length) {
        this.$bvModal.hide("membersModal");
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      if (this.membersSelect.length === 0) {
        this.error = this.$t("label.noMemberChoose");
        return;
      }
      let groupMembersList = this.$store.getters.getGroupMemberTest;
      let groupId = this.rowItem.GroupId;
      let find = groupMembersList.find((item) => {
        return item.rowItem.GroupId === groupId && item.groupingItem.Id === this.groupingItem.Id;
      });
      if (find) {
        let newList = groupMembersList.filter((item) => {
          return item.rowItem.GroupId !== groupId && item.groupingItem.Id === this.groupingItem.Id;
        });
        this.$store.commit("removeGroupMembersListTest", newList);
      }
      let obj = {
        rowItem: this.rowItem,
        members: this.membersSelect,
        groupingItem: this.groupingItem
      };
      //this.$store.commit("addGroupMembersList", obj);
      this.$store.commit("addGroupMemberTest", obj);

      this.$bvModal.hide(this.modalid);

      //this.success = true;
    },
    getMemberOf(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
      axios
        .get(graphEndpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            ConsistencyLevel: "eventual",
          },
        })
        .then((response) => {
          let membersList = response.data.value;
          this.membersList = membersList.map((item) => {
            return {
              value: item,
              text: item.displayName,
            };
          });

          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
